import styled, { css } from "styled-components";

export const TippWrapper = styled.div`
  position: absolute;
  top: 145px;
  width: ${({ width }) => (width ? width : 320)}px;

  ${({ position }) =>
    position === "left_sided" &&
    css`
      padding-left: 16px;
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      align-items: baseline;
    `}
`;

export const Tipp = styled.div`
  background: #fff5d6;
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  position: relative;
  padding-bottom: 24px;
`;

export const FlexDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ArrowPointer = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0px 12px 14px 12px;
  border-color: transparent transparent #fff5d6 transparent;
  position: absolute;
  top: 10px;
  left: ${({ left }) => (left ? left : "10%")};
`;

export const TippSection = styled.div`
  font-size: 13px;
  color: #000000;
  font-weight: 100;
  opacity: 0.4;
  margin: ${({ margins }) => margins || "15px 0"};
  max-width: 98%;
  line-height: 18px;
  font-family: "Rubik", sans-serif;

  svg {
    opacity: 0.5;
    position: relative;
    top: -5px;
  }

  span {
    font-weight: 600;
  }
`;

export const JobSection = styled.div`
  font-weight: 600;

  select {
    width: 100%;
    cursor: pointer;
    background: none;
    &:hover {
      background: #99938026;
    }
  }
`;

export const JobCategorySelector = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  select {
    width: 90%;
    cursor: pointer;
    background: none;
    &:hover {
      background: #99938026;
    }
  }
`;

export const TippInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: baseline;
  text-align: left;
  width: 80%;

  h2 {
    margin: 0px;
    font-size: 15px;
    font-weight: 500;
    color: #586368;
  }

  p {
    font-size: 13px;
    color: #000000;
    opacity: 0.4;
    max-width: 98%;
    line-height: 18px;
    margin-top: 4px;
  }
`;

export const Barometer = styled.div`
  margin-left: 10px;
  margin-right: 6px;

  img {
    width: 24px;
    height: 24px;
    margin-top: -5px;
    position: relative;
    top: 3px;
    left: 0;
  }
`;
